import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './accordion-item.component.html';
var AccordionItemComponent = (function () {
    function AccordionItemComponent() {
        this.isContentVisible = false;
    }
    AccordionItemComponent.prototype.toggleContentVisibility = function () {
        this.isContentVisible = !this.isContentVisible;
    };
    AccordionItemComponent.$inject = [];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], AccordionItemComponent.prototype, "title", void 0);
    AccordionItemComponent = __decorate([
        Component({
            selector: 'accordionItem',
            template: template,
            transclude: true,
        })
    ], AccordionItemComponent);
    return AccordionItemComponent;
}());
export { AccordionItemComponent };
